<div class="dynamic-modal-popup" (click)="close($event)">
  <div class="application-switcher-modal absolute top-60 right-xs bg-white b-white">
    <application-switcher [mobile]="true"></application-switcher>
  </div>
</div>
